import * as Sentry from "@sentry/react";

const TIMED_OUT = Symbol("timed-out");

export const withTimeout = async (
  promise: Promise<unknown>,
  ms: number,
  label: string,
) => {
  let timer: ReturnType<typeof setTimeout> | undefined;

  const timeout = new Promise<typeof TIMED_OUT>((resolve) => {
    timer = setTimeout(() => resolve(TIMED_OUT), ms);
  });

  try {
    if ((await Promise.race([promise, timeout])) === TIMED_OUT) {
      Sentry.captureMessage(
        `${label} did not complete within ${ms}ms`,
        "warning",
      );
    }
  } finally {
    clearTimeout(timer);
  }
};
